import { Module, ActionContext } from 'vuex'
import { RootState, AdPublishingState } from './state_models'
import AdPublishingService from '../services/AdPublishingService'
import { AD_PUBLISHING_STANDARD_PLAN } from '../util/constants'

let pendingFetchPromise: Promise<void> | null = null

export const adPublishing: Module<AdPublishingState, RootState> = {
  namespaced: true,
  state: { adPublishingLocationConfig: {}, fetchingLocationConfig: false },
  getters: {
    getForLocation: (state: AdPublishingState) => {
      return () => state.adPublishingLocationConfig
    },
    isFetchingLocationConfig: (state: AdPublishingState) => {
      return state.fetchingLocationConfig
    },
  },
  mutations: {
    set: (state: AdPublishingState, payload: { adPublishingLocationConfig?: { [key: string]: any } }) => {
      state.adPublishingLocationConfig = payload.adPublishingLocationConfig || {}
    },
    resetFetchingLocationConfig: (state: AdPublishingState) => {
      state.fetchingLocationConfig = false
    },
    setFetchingLocationConfig: (state: AdPublishingState, value: boolean) => {
      state.fetchingLocationConfig = value
    },
  },
  actions: {
    async syncAll(context: ActionContext<AdPublishingState, RootState>, locationId: string) {
      if (!locationId) return
      /**
       * If fetching location config is already in progress, return the pending promise
       * so callers can await the same fetch
       * */
      if (context.state.fetchingLocationConfig && pendingFetchPromise) {
        return pendingFetchPromise
      }
      context.commit('setFetchingLocationConfig', true)
      pendingFetchPromise = (async () => {
        try {
          const locationConfiguration = await AdPublishingService.getLocationConfiguration(
            locationId,
            AD_PUBLISHING_STANDARD_PLAN
          )
          context.commit('set', {
            adPublishingLocationConfig: { ...locationConfiguration, locPlan: AD_PUBLISHING_STANDARD_PLAN },
          })
        } catch {
          // Error is handled silently
        } finally {
          context.commit('setFetchingLocationConfig', false)
          pendingFetchPromise = null
        }
      })()
      return pendingFetchPromise
    },
    async resetFetchingLocationConfig(context: ActionContext<AdPublishingState, RootState>) {
      try {
        context.commit('resetFetchingLocationConfig')
      } catch {
        return
      }
    },
  },
}
